'use client';
import React from 'react';
import Link from 'next/link';
import { LayoutDashboard, Compass, Gamepad2, Wallet, User } from 'lucide-react';

interface MobileBottomNavProps {
  activePath: string;
}

const navItems = [
  { icon: LayoutDashboard, label: 'Home', href: '/user-dashboard' },
  { icon: Compass, label: 'Explore', href: '/discover-screen' },
  { icon: Gamepad2, label: 'Play', href: '/activity-detail-page' },
  { icon: Wallet, label: 'Wallet', href: '/wallet-screen' },
  { icon: User, label: 'Profile', href: '/user-dashboard' },
];

export default function MobileBottomNav({ activePath }: MobileBottomNavProps) {
  return (
    <nav className="bottom-nav">
      <div className="flex items-center justify-around w-full px-2">
        {navItems.map((item) => {
          const isActive = activePath === item.href;
          return (
            <Link
              key={`mob-nav-${item.label}`}
              href={item.href}
              className="flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-all"
              style={{
                color: isActive ? '#A78BFA' : 'var(--muted-foreground)',
                background: isActive ? 'rgba(124, 58, 237, 0.1)' : 'transparent',
              }}
            >
              <item.icon size={20} />
              <span style={{ fontSize: '10px', fontWeight: 600 }}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}